/**
 * This file is auto-generated from HowItWorksSection.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const howItWorksTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'How it works';
        case 'pl':
            return 'Jak to działa';
    }
};

export const howItWorksHeading: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Healthcare made simple';
        case 'pl':
            return 'Opieka medyczna. Prościej.';
    }
};

export const howItWorksStep1Title: Translation = lang => {
    switch (lang) {
        case 'en':
            return '1. Describe your symptoms';
        case 'pl':
            return '1. Opisz swoje objawy';
    }
};

export const howItWorksStep1Description: Translation = lang => {
    switch (lang) {
        case 'en':
            return "Answer a few short questions so we can direct you to the right doctor. We only ask about what's essential.";
        case 'pl':
            return 'Odpowiedz na kilka pytań, które pozwolą nam skierować Cię do odpowiedniego lekarza. Zapytamy tylko o to, co istotne.';
    }
};

export const howItWorksStep2Title: Translation = lang => {
    switch (lang) {
        case 'en':
            return '2. Consult with a specialist';
        case 'pl':
            return '2. Skonsultuj się ze specjalistą';
    }
};

export const howItWorksStep2Description: Translation<{ price: unknown }> = (lang, params) => {
    switch (lang) {
        case 'en':
            return [
                'The doctor will review your symptoms, make a diagnosis, and prepare your treatment plan. No waiting, at a price of ',
                params.price,
                ' per consultation.',
            ];
        case 'pl':
            return [
                'Lekarz przeanalizuje objawy, postawi diagnozę i przedstawi Ci plan leczenia. Bez kolejek, w cenie ',
                params.price,
                ' za konsultację.',
            ];
    }
};

export const howItWorksStep3Title: Translation = lang => {
    switch (lang) {
        case 'en':
            return '3. Receive a prescription or sick note';
        case 'pl':
            return '3. Otrzymaj receptę lub zwolnienie';
    }
};

export const howItWorksStep3Description: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'The doctor decides whether to issue prescriptions or sick leave certificates.';
        case 'pl':
            return 'Pamiętaj, że to zawsze lekarz decyduje o ich wystawieniu.';
    }
};

export const symptomHeadache: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Headache';
        case 'pl':
            return 'Ból głowy';
    }
};

export const symptomFever: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Fever';
        case 'pl':
            return 'Gorączka';
    }
};

export const symptomRunnyNose: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Runny nose';
        case 'pl':
            return 'Katar';
    }
};

export const patientWithSymptoms: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Patient with symptoms';
        case 'pl':
            return 'Pacjent z objawami';
    }
};
